import { FlexBox, Typography, Icon } from "@vp/swan";
import React from "react";

export const DebugInfoTextField = (props: {
  label: string;
  value?: string | number;
  link?: string;
}) => (
  <FlexBox mr={"6"} flexDirection="row">
    <Typography mr={"2"} fontWeight="bold">
      {props.label}:{" "}
    </Typography>
    <Typography>{props.value}</Typography>
    {props.link && <Icon iconType="info" />}
  </FlexBox>
);
